import React from "react";
import module from "./SubmitButton.module.css";
import { CircularProgress } from "@mui/material";
import PrimaryLinkButton from "../atomic/ui/PrimaryLinkButton";

const SubmitButton = ({ buttonLabel, isLoading, disabled }) => {
  return (
    <div className={module.textfield}>
      {isLoading ? (
        <div className={module.circle}>
          <CircularProgress color="success" />
        </div>
      ) : (
        <PrimaryLinkButton
          label={buttonLabel}
          type={"submit"}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default SubmitButton;
